var map = {
	"./color01_off.png": 6241,
	"./color02_off.png": 11253,
	"./color03_off.png": 48627,
	"./color04_off.png": 31035,
	"./color05_off.png": 62512,
	"./color06_off.png": 31157,
	"./color07_off.png": 75269,
	"./color08_off.png": 28731,
	"./color09_off.png": 5974
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77740;